import moment from 'moment';

export const getLastNDaysExcludingToday = (numberDays: number): { startDate: string; endDate: string } => {
  const endDate = moment().subtract(1, 'days').format('DD/MM/YYYY'); // Ayer
  const startDate = moment().subtract(numberDays, 'days').format('DD/MM/YYYY'); // Fecha hace numberDays días

  return { startDate, endDate };
};
